
import requestApi from "lib/services/api/common/boxp_api_client";
import { BASE_API_URL_BOXP } from "lib/constants";

const getAllIndirectJobs = (params) => (
    requestApi({

        url: `/indirect_job`,
        method: "GET",
        params,
    })
)

const createIndirectJobs = (formData) => {
    return requestApi({
        url: `/indirect_job`,
        method: "POST",
        data: formData
    });
};


const updateIndirectJobs = (data, id) => {
    return requestApi({
        url: `${BASE_API_URL_BOXP}/indirect_job/${id}?_method=PUT`,
        method: "POST",
        data,
    });
};

const getAllHistorys = (params) => (
    requestApi({

        url: `/job_clockings_history`,
        method: "GET",
        params,
    })
)

const updateHistoryManHours = (data, id) => {
    return requestApi({
        url: `/update_man_hours?_method=PUT`,
        method: "POST",
        data,
    });
};

const getAllClockingDetails = (params) => (
    requestApi({

        url: `/clockings`,
        method: "GET",
        params,
    })
)
const getAllRoutineDetails = (params) => (
    requestApi({

        url: `/get-routines-list`,
        method: "GET",
        params,
    })
)


const stopAllJobClockings = (data) => {
    return requestApi({
        url: `/stop_all_jobs?_method=PUT`,
        method: "POST",
        data,
    });
};

const stopAllJobPanelInfo = (params) => {
    return requestApi({
        url: `/get_duration_remaining`,
        method: "GET",
        params
    });
};
const updateAllocatedHours = (data) => {
    return requestApi({
        url: `/stop_clocking?_method=PUT`,
        method: "POST",
        data,
    });
};
const bulkStopAlljob = (data) => {
    return requestApi({
        url: `/bulk_stop`,
        method: "POST",
        data,
    });
};
const updateRoutine = (data) => {
    return requestApi({
        url: `/store-routine`,
        method: "POST",
        data,
    });
};

const deleteRoutine = (params) => {
    return requestApi({
        url: `/delete-routine`,
        method: "GET",
        params,
    });
};


export const JobClockingServices = {

    getAllIndirectJobs,
    createIndirectJobs,
    updateIndirectJobs,
    getAllHistorys,
    updateHistoryManHours,
    getAllClockingDetails,
    stopAllJobClockings,
    stopAllJobPanelInfo,
    updateAllocatedHours,
    bulkStopAlljob,
    getAllRoutineDetails,
    updateRoutine,
    deleteRoutine

}